import { Person, Sex } from '../types/form';

export function getPosition(person: Person): string {
  return person.sex === Sex.FEMALE ? 'komendantka chorągwi' : 'komendant chorągwi';
}
